var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.locales),function(locale){return _c('li',{key:locale,staticClass:"dropdown-content__value",on:{"click":function($event){return _vm.switchLocale(locale)}}},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(locale.toUpperCase()))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }